import { PHONE_MEDIA } from "./useIsPhone";

// Theme additions that only change phones. They live here, not in index.jsx, so the brand
// branches keep differing by colour only.
//
// iOS Safari zooms the whole page when an input with a font smaller than 16px gets focus, and
// Mantine's default is 14px. Every Mantine input (TextInput, Select, NumberInput, DatePickerInput,
// PasswordInput...) renders through Input, so this one rule covers them all. Desktop stays 14px.
export const phoneComponents = {
  Input: {
    styles: {
      input: { [PHONE_MEDIA]: { fontSize: 16 } },
    },
  },
};
